import classnames from "classnames";
import { FieldInputProps, connect as FormikConnect } from "formik";
import React, {
    FocusEvent,
    HTMLInputAutoCompleteAttribute,
    useState,
} from "react";
import { FormFeedback, Input } from "reactstrap";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { TextFieldProps } from "@components/Form/FormFields/TextField/textField.component.class";

import { BaseField } from "../Base/base.component";
import "./passwordField.scss";

const PasswordField = ({
    autoComplete,
    placeholder,
    test,
    disabled,
    ...baseFieldProps
}: TextFieldProps) => {
    const { t } = useGranite();

    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [showHint, setShowHint] = useState<boolean>(false);

    const toggleShowPassword = () => setShowPassword(current => !current);

    const handleOnFocus = () => setShowHint(true);

    const handleOnBlur =
        (field: FieldInputProps<unknown>) =>
        (event: FocusEvent<HTMLInputElement>) => {
            field.onBlur(event);
            setShowPassword(false);
            setShowHint(false);
        };

    return (
        <BaseField {...baseFieldProps}>
            {({ field, meta }) => (
                <div className="password-field">
                    <Input
                        data-test={test}
                        {...field}
                        id={field.name}
                        type={showPassword ? "text" : "password"}
                        placeholder={placeholder ? placeholder : ""}
                        autoComplete={
                            autoComplete as HTMLInputAutoCompleteAttribute
                        }
                        valid={meta.touched && !meta.error}
                        invalid={meta.touched && !!meta.error}
                        onFocus={handleOnFocus}
                        disabled={disabled}
                        onBlur={handleOnBlur(field)}
                    />
                    {showHint && (
                        <span
                            className={classnames(
                                "password-field__hint",
                                meta.touched &&
                                    !meta.error &&
                                    "password-field__hint--padded",
                            )}
                            onMouseDown={e => e.preventDefault()}
                            onClick={toggleShowPassword}
                        >
                            {showPassword
                                ? t("form.input.password.hint.hide")
                                : t("form.input.password.hint.show")}
                        </span>
                    )}
                    {meta.touched && !!meta.error && (
                        <FormFeedback>{meta.error}</FormFeedback>
                    )}
                </div>
            )}
        </BaseField>
    );
};

export default FormikConnect(PasswordField);
